function customProduct() {
  if($('.product').length){
    const userLoggedIn = $('.top-navigation-tools a.top-nav-button-account.secondary').length > 0;
    let userEmail = null;
  
    if (userLoggedIn) {
        userEmail = getShoptetDataLayer('customer').email;
    }
  
    const productCodeList = [];
    $('.product').each(function () {
        const $item = $(this);
        const $flagsDefault = $item.find('.flags-default');
        const $freeShipping = $item.find('.flags-extra .flag-freeshipping');
        if ($flagsDefault.length) {
          if ($freeShipping.length) {
            $flagsDefault.append($freeShipping);
          }
        }
        const singleProductCode = $(this).find('span[data-micro="sku"]').text().trim();
        if (singleProductCode) {
            productCodeList.push(singleProductCode);
        }
    });
  
    const fetchData = { codes: productCodeList };
    if (userEmail) {
        fetchData.email = userEmail;
    }
  
    fetch('https://tools.shopcode.cz/mojeRC/api/possibleInGarage.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(fetchData),
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP chyba: ${response.status}`);
            }
            return response.json();
        })
        .then((apiData) => {
            $('.product').each(function () {
                const $currentProduct = $(this);
                const currentProductCode = $currentProduct.find('span[data-micro="sku"]').text().trim();
  
                if (apiData[currentProductCode]) {
                    const { parkable, inGarage } = apiData[currentProductCode];
  
                    if (parkable) {
                        if (!$currentProduct.find('.addToGarage').length) {
                            const garageButtonHtml = userLoggedIn
                                ? `<div class="addToGarage ${inGarage ? 'inGarage' : ''}" data-code="${currentProductCode}">
                                        <span class="parking"></span>
                                    </div>`
                                : `<div class="addToGarage" data-code="${currentProductCode}">
                                        <a href="/registrace/" class="parking-link"></a>
                                    </div>`;
  
                            $currentProduct.find('.p').append(garageButtonHtml);
                        }
                    } else {
                        console.log(`Produkt ${currentProductCode} nelze zaparkovat do garáže.`);
                    }
                } else {
                    console.warn(`Data pro produkt ${currentProductCode} nebyla nalezena.`);
                }
  
                // Další manipulace s DOM
                moveElement($currentProduct, '.ratings-wrapper', '.p-bottom>div');
  
                if ($currentProduct.find('.flag-discount').length) {
                    moveElement($currentProduct, '.price-standard', '.prices', 'prepend');
                    moveElement($currentProduct, '.price-save', '.prices', 'append');
                }
  
                addDescriptionIfMissing($currentProduct);
                processAvailability($currentProduct);
            });
  
            initTooltips();
        })
        .catch((error) => {
            console.error('Chyba při načítání dat:', error);
        });
  }
  
}



// Funkce pro přesun elementů
function moveElement($parent, selector, targetSelector, method = 'append') {
  const $element = $parent.find(selector);
  if ($element.length) {
      $parent.find(targetSelector)[method]($element);
  }
}

// Přidání popisu, pokud neexistuje
function addDescriptionIfMissing($product) {
  if ($product.find('.p-desc').length < 1) {
      $product
          .find('.p-bottom>div')
          .append('<p class="p-desc" data-micro="description" data-testid="productCardShortDescr"></p>');
  }
}

// Zpracování dostupnosti produktu
function processAvailability($product) {
  const availabilityText = $product.find('.availability span').text().trim();
  if (availabilityMap[availabilityText]) {
      const hours = availabilityMap[availabilityText];
      const deliveryDate = calculateDeliveryDate(hours);
      const formattedDate = formatDate(deliveryDate);

      const bgColor = $product.find('.availability span').attr('style') || 'color:#000';

      $product
          .find('.availability span')
          .append(`<span class="question" style="background-${bgColor}">?</span>`)
          .addClass('show-tooltip')
          .attr('title', `Můžeme doručit do ${formattedDate}`)
          .attr('data-title', `Můžeme doručit do ${formattedDate}`);
  }
}
    

$(document).ready(function(){
    customProduct();
});
    
document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    customProduct();
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    customProduct();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    customProduct();
});

const fixedHolidays = [
    '01-01', // Nový rok
    '05-01', // Svátek práce
    '05-08', // Den vítězství
    '07-05', // Cyril a Metoděj
    '07-06', // Jan Hus
    '09-28', // Den české státnosti
    '10-28', // Den vzniku Československa
    '11-17', // Den boje za svobodu a demokracii
    '12-24', // Štědrý den
    '12-25', // 1. svátek vánoční
    '12-26'  // 2. svátek vánoční
  ];

  function formatDate(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  }

  function getEasterMonday(year) {
    const f = Math.floor,
          G = year % 19,
          C = f(year / 100),
          H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
          I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
          J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
          L = I - J,
          month = 3 + f((L + 40) / 44),
          day = L + 28 - 31 * f(month / 4);
    const easterSunday = new Date(year, month - 1, day);
    const easterMonday = new Date(easterSunday);
    easterMonday.setDate(easterMonday.getDate() + 1);
    
    return easterMonday;
  }

  function getGoodFriday(year) {
    const easterMonday = getEasterMonday(year);
    const goodFriday = new Date(easterMonday);
    goodFriday.setDate(easterMonday.getDate() - 3);
    return goodFriday;
  }

  function isHolidayOrWeekend(date) {
    const dayOfWeek = date.getDay();
    const formattedDate = date.toISOString().split('T')[0];
    const year = date.getFullYear();
    const isFixedHoliday = fixedHolidays.includes(formattedDate.slice(5));
    const easterMonday = getEasterMonday(year);
    const goodFriday = getGoodFriday(year);
    const isEasterMonday = (formattedDate === easterMonday.toISOString().split('T')[0]);
    const isGoodFriday = (formattedDate === goodFriday.toISOString().split('T')[0]);
    return (dayOfWeek === 0 || dayOfWeek === 6 || isFixedHoliday || isEasterMonday || isGoodFriday);
  }

  function calculateDeliveryDate(hoursToAdd) {
    let currentDate = new Date();
    let hoursAdded = 0;
    const currentHour = currentDate.getHours();
    const currentMinutes = currentDate.getMinutes();
    if (currentHour > 14 || (currentHour === 14 && currentMinutes > 30)) {
      hoursToAdd += 24;
    }
    while (hoursAdded < hoursToAdd) {
      currentDate.setHours(currentDate.getHours() + 1);
      if (!isHolidayOrWeekend(currentDate)) {
        hoursAdded++;
      }
    }
    return currentDate;
  }



  $('html').on('click', '.product .addToGarage', function(){
    const isLoggedIn = $('.top-navigation-tools a.top-nav-button-account.secondary').length > 0;
    if(isLoggedIn){
      const $button = $(this);
      const productCode = $(this).data('code');


      if (!productCode) {
          console.error('Kód produktu nebyl nalezen.');
          return;
      }
      if ($(this).hasClass('inGarage')) {
          removeFromGarageProducts(productCode);
          $(this).removeClass('inGarage');
      } else {
          addToGarageProducts(productCode);
          $(this).addClass('inGarage');
      }
    }
    else{
      
    }
    
  })

  function removeFromGarageProducts(productCode) {
    const email = getShoptetDataLayer('customer').email;
    if (!email) {
      console.error("Uživatel není přihlášen nebo se nepodařilo zjistit e-mail.");
      return;
    }
    $.ajax({
      url: "https://tools.shopcode.cz/mojeRC/api/garage_delete.php",
      method: "DELETE",
      contentType: "application/json; charset=UTF-8",
      data: JSON.stringify({
        email: email,
        code: productCode
      })
    })
    .done(function(response) {
      console.log("Produkt smazán:", response);
    })
    .fail(function(jqXHR, textStatus, errorThrown) {
      console.error("Chyba při mazání z garáže:", textStatus, errorThrown);
    });
  }

  function addToGarageProducts(productCode) {
    const email = getShoptetDataLayer('customer').email;
    if (!email) {
      console.error("Uživatel není přihlášen nebo se nepodařilo zjistit e-mail.");
      return;
    }
    $.ajax({
      url: "https://tools.shopcode.cz/mojeRC/api/garage_add.php",
      method: "POST",
      contentType: "application/json; charset=UTF-8",
      data: JSON.stringify({
        email: email,
        code: productCode
      })
    })
    .done(function(response) {
      console.log("Produkt přidán/aktualizován:", response);
      
      
      
    })
    .fail(function(jqXHR, textStatus, errorThrown) {
      console.error("Chyba při ukládání do garáže:", textStatus, errorThrown);
    });
  }